import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/ui';
import { Mastercard } from '@edikk-edikk/icon/payments/Mastercard';
import { Visa } from '@edikk-edikk/icon/payments/Visa';
import footerPaymentIconListCss from '#srcCssModules/footer/footer-payment-icon-list.module.scss';

const FooterPaymentIconList: FC = () => (
  <div className={footerPaymentIconListCss.footerPaymentIconList}>
    <SvgIcon Component={Mastercard} width={64} height={42} />
    <SvgIcon Component={Visa} width={66} height={24} />
  </div>
);

export { FooterPaymentIconList };
